import one from "../img/categories1.png";
import two from "../img/categories2.png";
import three from "../img/categories3.png";

export const seed = [
  { id: 0, image: one, title: "Concerts & Festivals" },
  { id: 1, image: two, title: "Performance Arts" },
  { id: 2, image: three, title: "Seminars" },
];
